import React from "react";
import HealthCentersTableWithFilters from "../../../components/HealthCenterComponents/newComponents/HealthCentersTableWithFilters";
import TopHeader from "../../../components/common/Header/TopHeader";
import DoctorManagementMenu from "../../../components/common/Menu/DoctorManagement";

const HealthCenters = () => {
    return (
        <main id="app">
            <TopHeader />
         <div className="content_wrapper">

                <section class="doctor-management-wrapper bg-white">
            <DoctorManagementMenu activeMenu='/healthCenter'/>
            </section>
                <div className="table-wrapper">
                    <HealthCentersTableWithFilters />
                </div>
            
        </div>
        </main>
    );
};

export default HealthCenters;
